import React from 'react';
import { Home, Calendar, Ticket, HelpCircle, User } from 'lucide-react';

interface MobileFooterProps {
  currentPage: string;
  onNavigate: (page: string) => void;
  darkMode: boolean;
}

export function MobileFooter({ currentPage, onNavigate, darkMode }: MobileFooterProps) {
  const menuItems = [
    { 
      icon: Home, 
      label: 'Home', 
      page: 'home',
      activeColor: 'text-orange-primary'
    },
    { 
      icon: Calendar, 
      label: 'Criar', 
      page: 'produtor',
      activeColor: 'text-orange-primary'
    },
    { 
      icon: Ticket, 
      label: 'Ingressos', 
      page: 'my-tickets',
      activeColor: 'text-orange-primary'
    },
    { 
      icon: HelpCircle, 
      label: 'Ajuda', 
      page: 'ajuda',
      activeColor: 'text-orange-primary'
    }
  ];

  const handleNavigation = (page: string) => {
    // Se for my-tickets, redirecionar para URL externa
    if (page === 'my-tickets') {
      window.location.href = 'https://uniqueingressos.com.br/login';
      return;
    }
    
    onNavigate(page);
  };

  // Função para obter cor do ícone
  const getIconColor = (isActive: boolean) => {
    if (isActive) {
      return 'text-orange-primary';
    }
    return darkMode ? 'text-white' : 'text-foreground';
  };

  // Função para obter cor do label
  const getLabelColor = (isActive: boolean) => {
    if (isActive) {
      return 'text-orange-primary font-medium';
    }
    return darkMode ? 'text-white/90' : 'text-foreground/85';
  };

  return (
    <footer className="mobile-footer-container">
      <div className="mobile-footer-content">
        <div className="mobile-footer-nav">
          {menuItems.map((item) => {
            const isActive = currentPage === item.page;
            const Icon = item.icon;
            
            return (
              <button
                key={item.page}
                onClick={() => handleNavigation(item.page)}
                className={`mobile-footer-item ${isActive ? 'mobile-footer-item-active' : ''}`}
                aria-label={item.label}
              >
                <div className="mobile-footer-icon-container">
                  <Icon 
                    size={20} 
                    className={`mobile-footer-icon ${getIconColor(isActive)}`}
                  />
                  {isActive && <div className="mobile-footer-active-indicator" />}
                </div>
                <span 
                  className={`mobile-footer-label ${getLabelColor(isActive)}`}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </footer>
  );
}